/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import WhiteCard from "../../shared/white-card";
import InputMobile from "../../shared/input-mobile";
import Button from "../../shared/button";
import Background from "./images/refer-page-illustration.svg";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import ReferFriend from "../../desktop/refer-friend/component";
import getReferPageUiState from "../../../utils/helpers/get-refer-page-ui-state";
import Skeleton from "./skeleton";
import H1 from "../../shared/h1/component";

const Refer = ({
    history,
    referralUrl,
    referralId,
    isSharePage,
    userPhoneNumber,
    isFetchingDetails,
    isLoggedIn,
    mobile,
    error,
    setUserPhoneNumberConnect,
    fetchReferralCodeConnect,
    sendReferralMessageConnect
}) => {
    const referFriendConfig = {
        twitter: {
            title: `I just sold my car at Cars24 in a single visit!

Check out Cars24 for the easiest way to sell your car. Get instant payment in your bank account with free RC transfer. Book appointment to visit the Cars24 branch today!`,
            shareText: "Share on Twitter",
            sharer: "https://twitter.com/intent/tweet",
            sharerURLKey: "url",
            sharerTitleKey: "text"

        },
        facebook: {
            title: `I just sold my car at Cars24 in a single visit!

Check out Cars24 for the easiest way to sell your car. Get instant payment in your bank account with free RC transfer. Book appointment to visit the Cars24 branch today!`,
            shareText: "Share on Facebook",
            sharer: "https://www.facebook.com/sharer/sharer.php",
            sharerURLKey: "u",
            sharerTitleKey: "quote"
        }
    };
    const [isValidMobileNumber, setIsValidMobileNumber] = useState(
        mobileNumberValidator(userPhoneNumber)
    );

    const [showError, setShowError] = useState(true);

    const [isFetchingLoggedInUserDetails, setIsFetchingLoggedInUserDetails] = useState((mobile && isLoggedIn));

    const onChangeMobile = ({ target: { value } }) => {
        const validNumber = mobileNumberValidator(value);
        setUserPhoneNumberConnect(value);
        setIsValidMobileNumber(validNumber);
    };

    const onClickActivate = () => {
        fetchReferralCodeConnect(userPhoneNumber)
            .then(({ referral_code: referralCode }) => {
                history.replace(`/refer/share/?r=${referralCode}`);
            });
    };

    useEffect(() => {
        if (mobile && isLoggedIn) {
            setIsFetchingLoggedInUserDetails(true);
            fetchReferralCodeConnect(mobile)
                .then(({ referral_code: referralCode }) => {
                    setIsFetchingLoggedInUserDetails(false);
                    history.replace(`/refer/share/?r=${referralCode}`);
                });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mobile, isLoggedIn]);

    useEffect(() => {
        if (error && error.message) {
            history.replace(`/refer/`);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    const uiState = getReferPageUiState({ isFetchingLoggedInUserDetails, isSharePage, referralUrl });

    const onClickErrorClose = () => {
        setShowError(false);
    };

    return (
        <div styleName={"styles.wrapper"}>
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-md-6"}>
                        <div styleName={"styles.maxWidth"}>
                            { (error && error.message && showError) &&
                        <div className="alert alert-danger mt-4" role="alert">
                            {error.message}
                            <button type="button" onClick={onClickErrorClose} className="close" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div> }
                            <H1 text="Share a better way of
                        Car Selling!" />
                            <div className={"d-sm-block d-md-none"} styleName="styles.illustration">
                                <img src={Background} alt="Share a better way of Car Selling!" />
                            </div>
                            <p>Think you know somebody who's selling a car?
                             Use your link to share your friends and family
                              a better way of car selling, the Cars24 way!</p>
                            { uiState === "preload_logged_in_user_data" && <Skeleton /> }
                            { uiState === "get_number" &&
                            <div styleName={"styles.card"}>
                                <WhiteCard>
                                    <h2>
                                  Enter your Mobile Number to activate sharing link!
                                    </h2>
                                    <InputMobile
                                        value={userPhoneNumber}
                                        onChange={onChangeMobile} />
                                    <Button
                                        text="Activate Now"
                                        disabled={!isValidMobileNumber}
                                        onClick={onClickActivate}
                                        isLoading={isFetchingDetails}
                                    />
                                </WhiteCard>
                            </div> }
                        </div>
                        { uiState === "refer_widget" && <div styleName={"styles.referContainer"}><ReferFriend
                            referral={{ referral_url: referralUrl, referral_id: referralId }}
                            sendReferralMessageConnect={sendReferralMessageConnect}
                            config={referFriendConfig}
                        /></div> }
                    </div>
                </div>
            </div>
        </div>
    );
};

Refer.propTypes = {
    history: PropTypes.object,
    userPhoneNumber: PropTypes.string,
    isFetchingDetails: PropTypes.bool,
    setUserPhoneNumberConnect: PropTypes.func,
    fetchReferralCodeConnect: PropTypes.func,
    isSharePage: PropTypes.func,
    referralUrl: PropTypes.string,
    sendReferralMessageConnect: PropTypes.func,
    referralId: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    mobile: PropTypes.string,
    error: PropTypes.object
};

export default Refer;
